import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import { AuthProvider } from "react-oidc-context";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";

const initialOptions = {
  "client-id": "Aek1O33ewfJDzetpUXbCIjvQWeQ1kXlZPKc7qbH68ZtQ5XZzZx8ebV3dCZsLDjnMMHGBcCuqSTq2ijQ-", // safe for client
  currency: "USD",
};

const cognitoAuthConfig = {
  authority: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_tuIEQzMAN",
  client_id: "6d9melljpa0v3lr720lgdsiot6",
  redirect_uri: "https://forbettertomorrow.org/loggedin",
  response_type: "code",
  scope: "phone openid email",
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
      <PayPalScriptProvider options={initialOptions}>
        <App />
      </PayPalScriptProvider>

    </AuthProvider>

  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
